import { EventCreatorMap } from '@app/analytics/models/helpers';

import ClickOnAccessiblityLink from './usablenet-click';

import * as HeaderActions from '@app/core/header/store/actions/header.action';

const eventsMap: EventCreatorMap = {
  [HeaderActions.CLICK_ON_ACCESSIBILITY_TOP_LINK]: ClickOnAccessiblityLink
};

export default eventsMap;
